











import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import MainMenuGroupingDesktop from '@/views/layout/navigation/grouping/main-menu-grouping-desktop.vue';
import MainMenuGroupingMobile from '@/views/layout/navigation/grouping/main-menu-grouping-mobile.vue';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
@Component({
  components: {
    MainMenuGroupingDesktop,
    MainMenuGroupingMobile
  }
})
export default class MainMenuGrouping extends mixins(UrlMixin) {
  //isMobile: boolean = true;
}
